<template>
  <observer-component :refId="'btoMyBetsLoadMore'">
    <my-bets-inline />
  </observer-component>
</template>
<script>
  import MyBetsInline from './my-bets-inline.vue';
  import ObserverComponent from '../../utilities/observer/observer-component';

  export default {
    name: 'ObservedMybets',
    components: { MyBetsInline, ObserverComponent },
  };
</script>